{
  "nl": {
    "ticket_category": {
      "Decisions": "Beslissing",
      "Issue": "Nazorg",
      "Regular": "Regulier",
      "labels": {
        "ticket_category": "Type"
      }
    }
  }
}
